import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiError } from '../../api/client';

/**
 * Puts an API error's field problems next to the matching inputs, and returns the
 * message for the form as a whole (shown above the buttons).
 */
export function applyApiError<T extends FieldValues>(err: unknown, setError: UseFormSetError<T>, known: readonly string[]): string {
  if (!(err instanceof ApiError)) return 'Something went wrong. Please try again.';
  let placed = 0;
  for (const [field, message] of Object.entries(err.fields)) {
    if (known.includes(field)) {
      setError(field as Path<T>, { type: 'server', message });
      placed++;
    }
  }
  // "Please check the highlighted fields" adds nothing when the fields already say it.
  return placed && placed === Object.keys(err.fields).length ? '' : err.message;
}
